import imageResize from 'utils/imageResize';
import Image from 'components/common/Image';
import EventDetails from 'components/EventDetails';
import PostHeader from 'components/PostHeader';
import CollaboratorsSlider from 'containers/CollaboratorsSlider';
import getMaxString from 'utils/getMaxString';
import fetchApi from 'hooks/fetchApi';
import API_NAME from 'services/api';
import { useRouter } from 'next/router';
import { useState } from 'react';
import EventSecretCodeDrawer from 'containers/EventSecretCodeDrawer';
import { IProfileCreateEventPost } from './IProfileCreateEventPost';

import {
  CoverImg,
  ProfileCreateEventPostWrapper,
  MediaWrapper,
  SocialActivityBlock,
  WheelMarkIconWrap,
} from './ProfileCreateEventPost.styles';

const ProfileCreateEventPost = ({
  profilePhoto,
  userId,
  creatorId,
  username,
  fullname,
  isVerified,
  isAmbassador,
  isDonor,
  isMe,
  followingStatus,
  postTime,
  isClickable,
  event,
  data,
  id,
  originId,
  collaborators,
  isAdmin,
}: IProfileCreateEventPost) => {
  const [open, setOpen] = useState<boolean>(false);
  const { action, loading } = fetchApi();
  const router = useRouter();

  const onAttendWithCode = async (v) => {
    try {
      const res = await action(API_NAME.EVENT_ATTENDS_WITHOUT_VEHICLE, {
        params: {
          eventId: data?._id,
        },
        body: {
          code: v?.secretCode,
        },
      });
      if (res?.result !== 'error') {
        setOpen(false);
        router.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getPostUrl = () => {
    const { origin: URLOrigin } = window.location;
    let url = URLOrigin;
    url = `${url}/e/${data?.originId}`;
    return url;
  };
  const onPostClick = () => {
    router.push(getPostUrl());
  };

  return (
    <>
      <ProfileCreateEventPostWrapper>
        <PostHeader
          profilePhoto={profilePhoto}
          userId={userId}
          username={username}
          fullname={fullname}
          creatorId={creatorId}
          isVerified={isVerified}
          isAmbassador={isAmbassador}
          isDonor={isDonor}
          isMe={isMe}
          followingStatus={followingStatus}
          postTime={postTime}
          type={6}
          id={id}
          data={data}
          originId={originId}
          isAdmin={isAdmin}
        />
        <MediaWrapper isClickable={isClickable} onClick={onPostClick}>
          {event?.coverPhoto?.trim() ? (
            <Image
              src={
                imageResize(event?.coverPhoto) ||
                event?.coverPhoto ||
                '/assets/img/tireTrace.png'
              }
              alt={getMaxString(event?.name, 8)}
              width={550}
              height={366}
              unoptimized
              priority
            />
          ) : (
            <CoverImg>
              <WheelMarkIconWrap>
                <Image
                  src="/assets/img/tireTrace.png"
                  alt="tire trace"
                  width={550}
                  height={366}
                  unoptimized
                  priority
                />
              </WheelMarkIconWrap>
            </CoverImg>
          )}
        </MediaWrapper>
        <SocialActivityBlock>
          <EventDetails
            data={data}
            event={event}
            type={6}
            isEventHomeTab={false}
            setOpen={setOpen}
          />
        </SocialActivityBlock>
        {collaborators?.length > 0 && (
          <CollaboratorsSlider collaborators={collaborators} />
        )}
      </ProfileCreateEventPostWrapper>
      <EventSecretCodeDrawer
        open={open}
        setOpen={setOpen}
        onSubmit={onAttendWithCode}
        inProgress={loading[API_NAME.EVENT_ATTENDS_WITHOUT_VEHICLE]}
      />
    </>
  );
};

export default ProfileCreateEventPost;
